<template>
    <div :class="[
        '__layout',
        { 'is-ie': isIE }
    ]">
        <LayoutHeader />
        <LayoutMain />
        <LayoutFooter />
        <Devtools v-if="false" />
        <Student />
        <LoaderOverlay
            :is-active="isSiteLoaderActive"
            :theme="siteLoaderTheme"
        />
        <Cookies />
    </div>
</template>

<script>
import '@/assets/scss/app.scss'
import Devtools from '@/components/devtools/Devtools';
import LayoutFooter from '@/components/layout/LayoutFooter'
import LayoutHeader from '@/components/layout/LayoutHeader'
import LayoutMain from '@/components/layout/LayoutMain'
import LoaderOverlay from '@/components/loader/LoaderOverlay'
import PluginIE from '@/plugins/ie'
import Student from '@/components/student/Student'
import Cookies from '@/components/cookies/Cookies'

export default {
    components: {
        Devtools,
        LayoutFooter,
        LayoutMain,
        LayoutHeader,
        LoaderOverlay,
        Student,
        Cookies
    },

    data() {
        return {
            isIE: false
        }
    },

    computed: {
        isSiteLoaderActive() {
            return this.$store.getters['siteLoader/isActive']
        },

        siteLoaderTheme() {
            let out = ['light', 'fixed']

            const extraTheme = this.$store.getters['siteLoader/theme']

            if (extraTheme !== null) {
                out.push(extraTheme)
            }

            return out
        },

        cookiesAllowed() {
            return this.$store.getters['cookies/isAllowed']
        },
    },

    beforeMount() {
        if (window.localStorage.getItem("cookiesAllowed")) {
            this.$store.dispatch('cookies/setIsAllowed', 1)
        }
    },

    mounted() {
        this.isIE = PluginIE.isIE() || PluginIE.isIE11()

        if (!window.ga && this.cookiesAllowed) {
            this.loadGTM2()
            this.loadGTM1()
            this.$ga.enable()
        }
    },

    methods: {
        loadGTM1() {
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start':
                        new Date().getTime(), event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-PHLMD75');
        },
        loadGTM2() {
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start':
                        new Date().getTime(), event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-TVRLF44');
        },
        loadGTM3() {
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start':
                        new Date().getTime(), event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-WV3QJWR');
        }
    },

    watch: {
        cookiesAllowed(isAllowed) {
            if (isAllowed) {
                this.loadGTM2()
                this.loadGTM1()
                this.loadGTM3()
                this.$ga.enable()
            }
        }
    }
}
</script>

<style lang="scss">
.__layout {
    padding: $value-height-header 0 0;

    @media (max-width: $screen-mobile-landscape) {
        padding: $value-height-header-mobile 0 0;
    }
}
</style>
